import { render, staticRenderFns } from "./ReferenceForm.vue?vue&type=template&id=58493804&"
import script from "./ReferenceForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VIcon,VTextarea})
